<div class="p-6 bg-white rounded-2xl shadow-xl w-full max-w-md text-center">
  <h2 class="text-xl font-semibold mb-2">
    {{ 'Procesando' }}
  </h2>

  <p class="text-gray-600 mb-6">
    {{ 'Por favor aguardá un momento…' }}
  </p>

  <div class="flex justify-center items-center pb-6">
    <svg
      class="spinner"
      width="44"
      height="44"
      viewBox="0 0 50 50"
      aria-label="Cargando"
    >
      <circle
        class="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="4"
      ></circle>
    </svg>
  </div>

<style>
  .spinner {
    animation: rotate 1s linear infinite;
  }
  .spinner .path {
    stroke: #0099FF; /* blue-600 */
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
  @keyframes rotate {
    100% { transform: rotate(360deg); }
  }
  @keyframes dash {
    0% { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
    50% { stroke-dasharray: 90, 150; stroke-dashoffset: -35; }
    100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124; }
  }
</style>
</div>
